import { locales } from "./locales";

export default function thousandsFormat(amount: number, lang: string) {
    return new Intl.NumberFormat(locales[lang], {
        useGrouping: true
    }).format(amount);
}
